// `Math.random()` is not a cryptographically secure source and its output is
// predictable, so ids that end up in request payloads (`sessionId`, cart item
// ids) are derived from the Web Crypto API instead. `crypto.getRandomValues` is
// available in every browser we support, including insecure contexts.
const randomBytes = (length) => {
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);
    return bytes;
};
const toHex = (bytes) => Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
export function generateUUID() {
    // `crypto.randomUUID` is secure-context only, so fall back to assembling an
    // RFC 4122 version 4 UUID from secure random bytes when it is unavailable.
    if (typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    const bytes = randomBytes(16);
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = toHex(bytes);
    return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20),
    ].join('-');
}
// This function is used to generate a unique id for the error. The output
// format is the exactly same used on the backend, on function "generateUniqueId"
// of Booking controller: 'xxxx-xxxx-xxxx' (where x is a hexadecimal digit).
export function generateErrorUniqueId() {
    const time = Date.now();
    // 4 bytes = 8 hex digits = the two random 4-digit groups of the format.
    const random = toHex(randomBytes(4));
    return [
        (time & 0xffff).toString(16).padStart(4, '0'),
        random.slice(0, 4),
        random.slice(4),
    ].join('-');
}
